import request from '@/utils/request'
import {applicationName} from '@/utils/const.js'

export function insert(data){
  return request({
    url:applicationName+'/admin/companydistribution',
    method:'POST',
    headers:{
      "Content-Type":"application/json;charset=utf-8"
    },
    data:JSON.stringify(data)
  })
}

export function deleted(data){
  return request({
    url:applicationName+'/admin/companydistribution',
    method:'delete',
    headers:{
      "Content-Type":"application/json;charset=utf-8"
    },
    data:JSON.stringify(data)
  })
}

export function queryArea(data){
  return request({
    url:applicationName+'/admin/companydistribution',
    method:'get',
    params:data
  })
}

export function queryAreaList(data){
  return request({
    url:applicationName+'/admin/companydistribution/arealist',
    method:'get',
    params:data
  })
}

export function queryShopList(data){
  return request({
    url:applicationName+'/admin/companydistribution/shoplist',
    method:'get',
    params:data
  })
}


export function update(data){
  return request({
    url:applicationName+'/admin/companydistribution',
    method:'put',
    headers:{
      "Content-Type":"application/json;charset=utf-8"
    },
    data:JSON.stringify(data)
  })
}